import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 5H5.82l.78-3.78L5.38 0 0 5.38V14h9.24L12 7.54zm2.76 5L12 16.46V19h6.18l-.78 3.78L18.62 24 24 18.62V10z"
}), 'ThumbsUpDownSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ThumbsUpDownSharp.js
// module id = 6797
// module chunks = 2